import { Close } from '@mui/icons-material';
import { LoadingButton } from '@mui/lab';
import {
  Autocomplete,
  Box,
  Button,
  CircularProgress,
  Dialog,
  IconButton,
  Stack,
  TextField,
  Radio,
  FormControl,
  FormLabel,
  RadioGroup,
  FormControlLabel,
} from '@mui/material';
import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';

export default function UpdateManager({ getTelecallersManager, manager }) {
  console.log('manager', manager);
  const { id } = useParams();
  const [open, setOpen] = useState(false);
  const [open1, setOpen1] = useState(false);
  const [managers, setManagers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [managerId, setManagerId] = useState('');
  const [buttonLoading, setButtonLoading] = useState(false);
  const [keepLeads, setKeepLeads] = useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const getManagers = async () => {
    try {
      const res = await axios.get(`${process.env.REACT_APP_API_URL}/leadTeam/leadManager/list`);
      console.log('managers list', res.data.data);
      if (res.data.isError) {
        toast.error(res.data.message);
      } else {
        const temp = res.data.data.records.filter((item) => item._id !== manager);
        setManagers(temp);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const updateManager = async () => {
    try {
      setButtonLoading(true);
      const res = await axios.put(`${process.env.REACT_APP_API_URL}/leadTeam/telecaller/manager`, {
        telecallerId: id,
        managerId,
        keepLeads,
      });
      getTelecallersManager();
      toast(res.data.message);
      handleClose();
      setButtonLoading(false);
    } catch (error) {
      console.log(error);
      toast.error(error.response.data.message);
      setButtonLoading(false);
    }
  };

  useEffect(() => {
    getManagers();
  }, [manager]);

  return (
    <Box>
      <Box id="basic-info" marginBottom={1}>
        <Box
          sx={{ boxShadow: '#d0cfcf 0px 1px 4px', borderRadius: '10px', bgcolor: 'background.paper' }}
          paddingX={{ xl: 2, lg: 2, md: 2, sm: 1, xs: 0.5 }}
          paddingY={1}
        >
          <Stack direction="row" alignItems="center" justifyContent="center">
            <Button variant="contained" onClick={() => setOpen(true)}>
              Change Manager
            </Button>
          </Stack>
        </Box>
      </Box>
      <Dialog open={open} onClose={handleClose} fullWidth>
        <Box padding={2}>
          <Stack direction="column" spacing={3} alignItems="center" justifyContent="center">
            <Stack
              direction="row"
              alignItems="center"
              justifyContent="space-between"
              sx={{
                width: '100%',
              }}
            >
              <h3>Change Manager</h3>
              <IconButton onClick={handleClose}>
                <Close />
              </IconButton>
            </Stack>
            <Autocomplete
              id="asynchronous-demo"
              fullWidth
              open={open1}
              onOpen={() => {
                setOpen1(true);
              }}
              onClose={() => {
                setOpen1(false);
              }}
              isOptionEqualToValue={(option, value) => option.fullname === value.fullname}
              getOptionLabel={(option) => option.fullname}
              options={managers}
              loading={loading}
              onChange={(_, value) => setManagerId(value._id)}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Sales Manager"
                  InputProps={{
                    ...params.InputProps,
                    endAdornment: (
                      <>
                        {loading ? <CircularProgress color="inherit" size={20} /> : null}
                        {params.InputProps.endAdornment}
                      </>
                    ),
                  }}
                />
              )}
            />

            <Stack direction="row" alignItems="center" justifyContent="start" width={'100%'}>
              <FormControl component="fieldset">
                <FormLabel component="legend">Keep RFQs With Sales Staff</FormLabel>
                <RadioGroup
                  row
                  aria-label="keepLeads"
                  name="row-radio-buttons-group"
                  value={keepLeads}
                  onChange={(e) => setKeepLeads(e.target.value)}
                >
                  <FormControlLabel value="true" control={<Radio />} label="Yes" />
                  <FormControlLabel value="false" control={<Radio />} label="No" />
                </RadioGroup>
              </FormControl> 
            </Stack>
            <LoadingButton loading={buttonLoading} onClick={updateManager} variant="contained">
              Assign Manager
            </LoadingButton>
          </Stack>
        </Box>
      </Dialog>
    </Box>
  );
}
